import * as React from 'react';
import { getLinkUrl } from '@own-local/ad-utils/lib/url';

const WIDTH_OFFSET = 2;
const HEIGHT_OFFSET = 70;

export interface FacebookContentProps {
  active: boolean;
  facebookLink: string;
  gamTrackingUrl?: string;
}

const FacebookContent = (props: FacebookContentProps) => {
  const { active, facebookLink, gamTrackingUrl } = props;

  const getWidgetSize = () => {
    const size = { width: 0, height: 0 };
    const widgetElement = document.getElementsByClassName("content-active")[0];
    if (widgetElement) {
      size.width = widgetElement.clientWidth + WIDTH_OFFSET;
      size.height = widgetElement.clientHeight + HEIGHT_OFFSET;
    }
    return size;
  }

  const size = getWidgetSize();
  const widgetUrl = `https://www.facebook.com/v2.12/plugins/page.php?adapt_container_width=true&
    hide_cover=true&show_facepile=false&small_header=true&tabs=timeline&width=${size.width}&
    height=${size.height}&href=${facebookLink}`;

  return (
    <div className={`content-wrapper feed ${active && 'content-active'}`}>
      <div className="social-modal-content">
        <iframe src={active ? getLinkUrl(widgetUrl, gamTrackingUrl) : ''}></iframe>
      </div>
    </div>
  );
};

export default FacebookContent;
